import { mutatorAction } from 'satcheljs';
import { feedbackRibbonStore } from '../store/store';

export let resetFeedbackRibbonState = mutatorAction(
    'resetFeedbackRibbonState',
    (sessionId: string) => {
        feedbackRibbonStore.mountedRibbons.delete(sessionId);
    }
);
